import { Link } from "react-router-dom";
import { useCookiePreferences } from "../context/CookieContext";
import { BRAND } from "../config/brand";

function Footer() {
  const { openPreferences } = useCookiePreferences();

  return (
    <footer className="bg-white border-t border-slate-200 py-5 text-center">
      <div className="flex flex-col items-center gap-2 sm:flex-row sm:justify-center sm:gap-4 text-sm">
        <span className="text-slate-500">
          &copy; {new Date().getFullYear()} {BRAND.productName}. All rights reserved.
        </span>
        <Link
          to="/legal"
          className="font-medium text-blue-600 hover:text-blue-700 transition"
        >
          Legal Notice
        </Link>
        <button
          type="button"
          onClick={openPreferences}
          className="font-medium text-blue-600 hover:text-blue-700 transition"
        >
          Cookie Preferences
        </button>
      </div>
    </footer>
  );
}

export default Footer;
